import {NavLink} from 'react-router-dom';

// Config
import { talentDashboardRoute } from '~config/routes';



export default function HeadNavigationTalent() {
    return (
        <nav className="header-talent-nav">
            <NavLink className="header-talent-nav__link" to={talentDashboardRoute}>
                <span className="header-talent-nav__label">My Page</span>
            </NavLink>
        </nav>
    );
}
